import type React from 'react';
import { NavLink } from 'react-router-dom';
import { useWebSettings } from '@shared/hooks';
import * as st from './styles.module.scss';

export const Logo: React.FC = () => {
  const { logo, logo_url } = useWebSettings();
  return (
    <>
      {logo_url ? (
        <a className={st.logo__a} href={logo_url}>
          <img className={st.logo__img} src={logo ?? ''} alt="" />
        </a>
      ) : (
        <NavLink
          to="/"
          onClick={() => {
            if (window.location.pathname === '/') {
              const iframe = document.getElementById('mainPageIframe') as HTMLIFrameElement;
              iframe && (iframe.src = iframe.src);
            }
          }}
        >
          <img className={st.logo__img} src={logo ?? ''} alt="" />
        </NavLink>
      )}
    </>
  );
};
